<ion-button fill="clear" style="color: inherit;" (click)="onSwapLangBtnClicked($event)">
    <ion-img style="width: 25px; margin-right: 2px;" [src]="imgSource"></ion-img>
    <ion-icon  name="caret-down-outline" style="color: inherit; font-size: 14px;"></ion-icon>
</ion-button>   
